// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/login","layout":false,"id":"1"},"2":{"path":"/","requireLark":false,"redirect":"/manage","id":"2"},"3":{"path":"/manage","requireLark":false,"id":"3"},"4":{"path":"","requireLark":false,"redirect":"/manage/supplierManage","parentId":"3","id":"4"},"5":{"path":"supplierManage","name":"供应商管理","requireLark":false,"parentId":"3","id":"5"},"6":{"path":"addSupplier","requireLark":true,"parentId":"3","id":"6"},"7":{"path":"formResults/:id","requireLark":true,"parentId":"3","id":"7"},"8":{"path":"/form/:id","name":"供应商信息填写","requireLark":false,"id":"8"}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import(/* webpackChunkName: "p__Login__index" */'@/pages/Login/index.tsx')),
'2': React.lazy(() => import('./EmptyRoute')),
'3': React.lazy(() => import(/* webpackChunkName: "layout__index" */'@/layout/index.tsx')),
'4': React.lazy(() => import('./EmptyRoute')),
'5': React.lazy(() => import(/* webpackChunkName: "p__SupplierManage__index" */'@/pages/SupplierManage/index.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__SupplierManage__AddSupplier__index" */'@/pages/SupplierManage/AddSupplier/index.tsx')),
'7': React.lazy(() => import(/* webpackChunkName: "p__FormResults__index" */'@/pages/FormResults/index.tsx')),
'8': React.lazy(() => import(/* webpackChunkName: "p__BasicInfo__index" */'@/pages/BasicInfo/index.tsx')),
},
  };
}
